import { ColumnLabel, ColumnValue } from "./Columns";
import { getProductStatusLabel, Product } from "../../product";

export const ProductListStatusColumn = {
  name: ColumnValue.Status,
  label: ColumnLabel[ColumnValue.Status],
  default: true,
  renderCell: (p: Product): string => getProductStatusLabel(p.status),
};
